import React from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { styled } from 'styled-components';
import { formatAmountToLocaleString } from 'helpers/accountsHelpers';
import { FormInputAmount, FormInputAmountProps } from '@ui';

// components
import InfoTooltip from 'components/Tooltips/InfoTooltip';
import DivAlignCenter from 'components/Additional/DivAlignCenter';

export interface TransactionAmountFieldProps extends FormInputAmountProps {
  wireFee?: number;
}

const TransactionAmountField = ({
  wireFee,
  ...rest
}: TransactionAmountFieldProps) => {
  const { t } = useTranslation('transfers');
  return (
    <DivAlignCenter>
      <StyledFormAmountField {...rest} />
      {wireFee ? (
        <StyledInfoTooltip
          tooltipContent={t('international_transfer.transaction_fee', {
            fee: formatAmountToLocaleString(wireFee),
          })}
        />
      ) : null}
    </DivAlignCenter>
  );
};

const StyledFormAmountField = styled(FormInputAmount)`
  width: 100%;
`;

const StyledInfoTooltip = styled(InfoTooltip)`
  margin-left: ${({ theme }) => theme.marginXs};
`;

export default TransactionAmountField;
